import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.7 8.2c-.2-.2-.5-.2-.7 0l-5.5 5.5V1.3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.5L2 8.2c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l6 6c.4.4 1 .4 1.4 0l6-6c.2-.2.2-.5 0-.7" />
  </svg>
);
const SvgArrowDown = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="arrow-down" {...props} />;
export default SvgArrowDown;
